export default {
  meta: {
    title: '案例管理'
  }
};
